module.exports = __webpack_public_path__ + "static/media/ic-claim-success.7e59944a.svg";